import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
  },
  title: {
    textAlign: "left",
    color: "#667085",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
    letterSpacing: "0em",
  },
  tooltipInfo: {
    cursor: "help",
    marginLeft: "8px",
  },
  iconButton: {
    transition: "opacity .5s ease-in-out",
  },
}));

export default styles;
